interface ShareCodeParams {
  otp: string;
  orderId: string;
  fileName?: string;
  expiresAt?: string | null; // ISO date string
}

function formatExpiry(expiresAt: string): string {
  return new Date(expiresAt).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function buildOtpMessage({
  otp,
  orderId,
  fileName,
  expiresAt,
}: ShareCodeParams): string {
  return [
    '🖨️ *Kiosk Printing – Release Code*',
    '',
    'Your print request is ready. Please use the release code below at the kiosk to securely release your document.',
    '',
    `🔐 *Release Code:* ${otp}`,
    `📋 *Order ID:* ${orderId}`,
    fileName ? `📄 *File:* ${fileName}` : null,
    expiresAt
      ? `⏰ *Valid Until:* ${formatExpiry(expiresAt)}`
      : null,
    '',
    'Please enter the release code at the kiosk to start printing.',
    '',
    'Thank you for using our kiosk printing service.',
  ]
    .filter(Boolean)
    .join('\n');
}

export function shareOnWhatsApp(params: ShareCodeParams): void {
  const url = `https://wa.me/?text=${encodeURIComponent(
    buildOtpMessage(params)
  )}`;

  window.open(url, '_blank', 'noopener,noreferrer');
}
